export default __webpack_public_path__ + "static/media/Version (2) - Prisoner of Azkaban_22.4a51d95a.jpg";